const color = {
    brightBlue: '#3498db',
    
    darkGrayishBlue: '#8b8d94',
    darkRed: '#a90000',
    grayishBlue: 'white',
    grayishBlue2: '#9fa2b4',
    grayishBlue3: '#bdc3c7',

    lightBlue: '#3751FF',
    lightGrayishBlue: '#F7F8FC', // background color
    lightGrayishBlue2: '#DFE0EB',
    paleBlue: 'white',//mouse hover icon
    paleBlueTransparent: 'rgba(221, 226, 255, 0.08)',//mousehover
    veryDarkGrayishBlue: ' rgb(36, 38, 128)'
};

const typography = {
    cardTitle: {
        fontWeight: '1000',
        fontSize: 35,
        lineHeight: '30px',
        letterSpacing: '0.4px'
    },
    smallSubtitle: {
        fontSize:  40,
        fontWeight: '900',
        lineHeight: '16px',
        letterSpacing: '0.1px',
        paddin:'20%'
    },
    link: {
        fontWeight: '800',
        fontSize: 14,
        lineHeight: '20px',
        letterSpacing: '0.2px',
        color: color.lightBlue,
        textAlign: 'right',
        cursor: 'pointer',
        textDecoration: 'underline',
        '&:hover': {
            color: color.white
        }
    },
    itemTitle: {
        fontWeight: 900,
        fontSize: 25,
        lineHeight: '38px',
        letterSpacing: 0.2
    },
    title: {
        fontWeight: '900',
        fontSize: 30,
        lineHeight: '30px',
        letterSpacing: 0.3
    }
};

export default {
    // https://www.colorhexa.com/A4A6B3
    color,
    typography
};
